export default {"src":"/_next/static/media/Group-25846.624114b5.svg","height":104,"width":104};